import { IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { PlannedTerm } from '../../../../global/builders/planned_term_builder';
import { APPreviewPlanServant } from '../../../../preferences/components/preview_plan/components/preview_terms_plan_header/servants/ap_preview_plan_servant';
import { IPlanFeedbackTerm } from '../builders/plan_feedback_term_builder';
import { IPlanFeebackTermsDatasource } from '../datasources/plan_feedback_terms_datasource';

export class AdvisorSentFeedbackGraduationTimeQuery implements IQuery {
  private _result: {
    graduationTime: string;
  };

  constructor(QueryMediator: IQueryMediator, private ngPlanFeebackTermsDatasource: IPlanFeebackTermsDatasource) {
    QueryMediator.registerQuery(this, ngPlanFeebackTermsDatasource);
  }

  run(): this {
    let terms: PlannedTerm[] = _4.map(this.ngPlanFeebackTermsDatasource.read(), 'term');
    terms = _4.sortBy(terms, (term: IPlanFeedbackTerm['term']) => moment(term.term_start_dt));
    this._result = {
      graduationTime: APPreviewPlanServant.getEstimatedGraduationDateFromTerm(terms)
    };
    return this;
  }

  get result() {
    return this._result;
  }
}

angular
  .module('capability-ng-academic-planner')
  .service('ngAPAdvisorSentFeedbackGraduationTimeQuery', AdvisorSentFeedbackGraduationTimeQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/queries/advisor_sent_feedback_graduation_time_query.ts